









import { Component } from "vue-property-decorator";
import { mixins } from "vue-class-component";

import Flow from "./Flow/index.vue";

import FlowMixin from "@/mixins/flow";

@Component({
  components: {
    Flow,
  },
})
export default class Drop extends mixins(FlowMixin) {}
